// extracted by mini-css-extract-plugin
module.exports = {"information-button":"InformationButton-InformationButton-information-button-bM1Xxz0G","informationButton":"InformationButton-InformationButton-information-button-bM1Xxz0G"};